import GiveawayForm from '../components/GiveawayAutoForm';
import useNewGiveawayAuto from './useNewGiveawayAuto';

export default function NewGiveawayAuto() {
    const {
        handleSubmit,
        createdGiveaway
    } = useNewGiveawayAuto();

    return (
        <GiveawayForm action='Adicionar' onSubmit={handleSubmit} createdGiveaway={createdGiveaway} />
    )
}
